import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureMariaDBCopySource } from 'app/model/pipeline/copysource/azure-maria-db.copysource';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMariaDBCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class AzureMariaDBCopySourceAdapter extends CopySourceAdapter<AzureMariaDBCopySource, Model.MariaDBSource> {
    protected override async _toResource(copySource: AzureMariaDBCopySource): Promise<Model.MariaDBSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(AzureMariaDBCopySource).name);
    }

    protected override async _toModel(
        resource: Model.MariaDBSource,
        copyActivity: CopyActivity
    ): Promise<AzureMariaDBCopySource> {
        return this._toTabularModel(resource, copyActivity, AzureMariaDBCopySource.MODEL);
    }
}
